import React, { useEffect } from 'react';

export function SEO({
  title,
  description = "Fodtid – Professionel mobil fodpleje i eget hjem. Vi dækker hele Sjælland (minus øerne) mandag til lørdag kl. 9-18. Ring 82 82 10 10.",
  image = "https://assets.auxodev.dk/assets/d4428667-cde9-4c31-9224-88278506a01a/fodtid-hero-mobile-care.png",
  url = window.location.href,
  type = "website"
}) {
  const fullTitle = title 
    ? (title.toLowerCase().includes('fodtid') ? title : `${title} | Fodtid`)
    : "Fodtid | Professionel mobil fodpleje i eget hjem";

  useEffect(() => {
    document.title = fullTitle;

    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = description;

    // Update OG tags
    const ogTags = {
      'og:title': fullTitle,
      'og:description': description,
      'og:image': image,
      'og:url': url,
      'og:type': type
    };

    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });

    // Twitter tags
    const twitterTags = {
      'twitter:card': 'summary_large_image',
      'twitter:title': fullTitle,
      'twitter:description': description,
      'twitter:image': image
    };

    Object.entries(twitterTags).forEach(([name, content]) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, [fullTitle, description, image, url, type]);

  return null;
}
